<mat-toolbar color="">
  <mat-nav-list *ngIf="isLoggedIn" class="list-horizontal">
    <mat-list role="list">
      <mat-list-item>
        <a mat-list-item routerLink="/home" routerLinkActive="active">Home</a>
      </mat-list-item>
      <mat-list-item *ngIf="hasAdminAccess">
        <a mat-list-item routerLink="/super-admin" routerLinkActive="active">Admin</a>
      </mat-list-item>
      <mat-list-item>
        <a mat-list-item routerLink="/logout" routerLinkActive="active">Logout</a>
      </mat-list-item>
    </mat-list>
  </mat-nav-list>
</mat-toolbar>